export const participants = [
  {
    id: 'user1',
    name: 'Matteo',
    imageUrl: require('@/assets/imgs/tx1.png')
  },
  {
    id: 'me',
    name: 'Support',
    imageUrl: require('@/assets/imgs/tx.png')
  }
]

export const colors = {
  header: {
    bg: '#4e8cff',
    text: '#ffffff'
  },
  launcher: {
    bg: 'transparent'
  },
  messageList: {
    bg: 'rgba(245, 248, 249, 1)'
  },
  sentMessage: {
    bg: 'rgba(255, 255, 255, 1)',
    text: '#000'
  },
  receivedMessage: {
    bg: 'rgba(255, 255, 255, 1)',
    text: '#222222'
  },
  userInput: {
    bg: 'rgba(255, 255, 255, 1)',
    text: '#565867'
  }
}